// extracted by mini-css-extract-plugin
export default {"attributes":"mobile-selected-tracker-bar_attributes__cJpF0"};